<template>
  <section class="booking-mobile-buttons">
    <!-- Mobile buttons -->
    <div
      class="container hidden-md hidden-lg padding-bottom-xs-2"
      v-if="filteredActivityGroups.length"
    >
      <div
        v-for="activityGroup in filteredActivityGroups"
        :key="'activity-group-' + activityGroup.activity_group_id"
        class="activity-group-items"
      >
        <span
          class="activity-group-anchor"
          :id="'activity-group-anchor-' + activityGroup.activity_group_id"
        ></span>
        <a
          class="nk-button force-icon-right link-plus-right margin-bottom-xs-1"
          :class="{
            'link-close-right': activityGroups.selected == activityGroup,
            'nk-button-light-nude':
              activityGroups.selected == activityGroup ||
              !activityGroups.selected,
            'nk-button-disabled': !cities.selected,
          }"
          @click.prevent="
            cities.selected &&
              (toggleActivityGroup(activityGroup),
              shouldDeselectTimeslot(),
              scrollToActivityGroupButton(activityGroup.activity_group_id));
          "
          >{{ activityGroup.activity_group_name }}</a
        >
        <div v-if="activityGroups.selected == activityGroup">
          <ul class="nk-list margin-top-xs-1 margin-bottom-xs-3">
            <li v-for="activity in filteredActivities">
              <a href="#" @click.prevent="handleSetActivity(activity)"
                ><span
                  v-if="activityIsCampaign(activity)"
                  class="campaign-offer-icon"
                  ><img
                    src="/wp-content/themes/nordiskakliniken/dist/images/star-solid.svg"
                /></span>
                {{ activity.activity_name }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState([
      'activityGroups',
      'activities',
      'providers',
      'cities',
      'selectedSlot',
      'dates',
      'ui',
      'booking',
      'patient',
    ]),
    ...mapGetters([
      'dateIsInThePast',
      'activityIsCampaign',
      'formatProviderName',
      'selectedSlotFormated',
      'formIsValid',
      'loading',
      'filteredActivityGroups',
      'filteredActivities',
    ]),
  },
  methods: {
    ...mapActions([
      'toggleActivityGroup',
      'setActivityGroup',
      'setActivity',
      'setupActiveDates',
      'setSelectedSlot',
      'setProvider',
      'getRealWeekday',
      'setModalState',
      'handleSwipe',
      'shouldDeselectTimeslot',
    ]),

    handleSetActivity(activity) {
      /* Don't let the user set the activity if we're loading times because this messes up the UI */
      if (this.loading.times) {
        return;
      }
      this.setActivity(activity);
      this.setModalState(3);
    },
    scrollToActivityGroupButton(activityGroupId) {
      if (this.loading.times) {
        return;
      }
      window.setTimeout(() => {
        let element = document.getElementById(
          'activity-group-anchor-' + activityGroupId
        );
        this.$SmoothScroll(element, 250);
      }, 150);
    },
  },
};
</script>
